import React from 'react';

import NavBarNameForm from '@dashboard/components/NavBarNameForm';
import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useUpdateEmailTemplateNameMutation, useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import { CalendarViewDayOutlined, TableRowsOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';

type Props = {
  templateId: string;
};
export default function NavBarName({ templateId: id }: Props) {
  const { data } = useWaypointTemplateQuery({ variables: { id } });
  const [updateName, { loading }] = useUpdateEmailTemplateNameMutation();

  const template = data?.WaypointTemplate;
  if (template === undefined) {
    return null;
  }

  const onSave = async (name: string) => {
    try {
      const n = name.trim().length === 0 ? 'Untitled template' : name.trim();
      await updateName({ variables: { id, name: n } });
      alertSuccess('Template name saved');
      return true;
    } catch (e) {
      alertError('Template name not saved');
      return false;
    }
  };
  const { name, type } = template;
  return (
    <>
      <NavBarNameForm key={name} initialValue={name} loading={loading} onSave={onSave} />
      <Chip
        variant="outlined"
        size="small"
        color="secondary"
        label={type === 'LAYOUT' ? 'Layout' : 'Template'}
        icon={type === 'LAYOUT' ? <TableRowsOutlined /> : <CalendarViewDayOutlined />}
        sx={{ color: 'inherit', display: { xs: 'none', md: 'flex' }, opacity: 0.8 }}
      />
    </>
  );
}
